import { useState } from 'react';

import { WorkOrdersConnectionInput } from '@atom/types/work';

export const RESULTS_PER_PAGE_OPTIONS = [25, 50, 100];

export type SortDirection = 'asc' | 'desc';

type WorkOrdersPageState = {
  page: number;
  limit: number;
  sortBy: string;
  sortDirection: SortDirection;
  filters: WorkOrdersConnectionInput;
};

const INITIAL_PAGE_STATE: WorkOrdersPageState = {
  page: 1,
  limit: RESULTS_PER_PAGE_OPTIONS[0],
  sortBy: 'name',
  sortDirection: 'asc',
  filters: {},
};

const useWorkOrdersPageState = () => {
  const [pageState, setPageState] =
    useState<WorkOrdersPageState>(INITIAL_PAGE_STATE);

  const onFiltersApply = (filters: WorkOrdersConnectionInput) =>
    setPageState(current => ({ ...current, filters, page: 1 }));

  const onSortChange = (sortBy: string, sortDirection: SortDirection) =>
    setPageState(current => ({ ...current, sortBy, sortDirection }));

  const onPageChange = (page: number) =>
    setPageState(current => ({ ...current, page }));

  const onLimitChange = (limit: number) =>
    setPageState(current => ({ ...current, limit, page: 1 }));

  return {
    ...pageState,
    onFiltersApply,
    onSortChange,
    onPageChange,
    onLimitChange,
  };
};

export default useWorkOrdersPageState;
